'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/weekAgo.js